import { render } from "./BaseDraggableModal.vue?vue&type=template&id=52f8e056"
import script from "./BaseDraggableModal.vue?vue&type=script&lang=js"
export * from "./BaseDraggableModal.vue?vue&type=script&lang=js"

import "./BaseDraggableModal.vue?vue&type=style&index=0&id=52f8e056&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__